import { render, staticRenderFns } from "./ProductDesc.vue?vue&type=template&id=49525251&scoped=true&"
import script from "./ProductDesc.vue?vue&type=script&lang=js&"
export * from "./ProductDesc.vue?vue&type=script&lang=js&"
import style0 from "./ProductDesc.vue?vue&type=style&index=0&id=49525251&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49525251",
  null
  
)

export default component.exports